import { render } from "./AttendanceDetailView.vue?vue&type=template&id=c583ccd0"
import script from "./AttendanceDetailView.vue?vue&type=script&lang=js"
export * from "./AttendanceDetailView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__